import EditOutletType from "./Edit";

export default function AddOutletType() {
    return <EditOutletType mode="add" />;
}
